<template>
	<o-select
		v-if="setup.companies.length"
		v-model="setup.vModel"
		:options="setup.selectOptions"
		track-key="id"
		display-key="name"
		value-key="id"
		disabled-key="disabled"
		v-bind="{
			...$attrs,
			label: setup.computedLabel(),
			clearable,
			searchable: setup.searchable,
			multiple,
		}"
		@select="emits('select', $event)">
		<template
			v-if="setup.self.isClient()"
			#option="{ item }">
			<div>
				<div>
					{{ `${item.name} (${item.contactDetailCity})` }}
				</div>
				<o-label
					v-if="item.agencyCompanyName && !hideAgencyName"
					outline
					style="margin-top: 0.25rem;">
					{{ item.agencyCompanyName }}
				</o-label>
				<o-label
					v-if="checkOrderPlugin && !item.canCreateOrder"
					style="margin-top: 0.25rem;"
					color="warning"
					outline>
					{{ $t('common.shared.components.selectUserCompany.contactAgencyForOrder') }}
				</o-label>
			</div>
		</template>
	</o-select>
	<slot
		v-else
		name="empty"/>
</template>

<script setup lang="ts">
// #region Setup
import type { SharedSelectUserCompanyEmits, SharedSelectUserCompanyProps } from './SharedSelectUserCompanySetup';
import SharedSelectUserCompanySetup from './SharedSelectUserCompanySetup';
const emits = defineEmits<SharedSelectUserCompanyEmits>() as SharedSelectUserCompanyEmits;
const props = withDefaults(defineProps<SharedSelectUserCompanyProps>(), SharedSelectUserCompanySetup.defaultProps);
const setup = new SharedSelectUserCompanySetup(props, emits);
defineExpose(setup.publicInstance);
// #endregion
</script>
